"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatBannerMarkup = formatBannerMarkup;
exports.removeH2FromPresenterBannerMarkup = removeH2FromPresenterBannerMarkup;
exports.updateBannerFont = exports.sanitizeHTML = void 0;
var _underscore = _interopRequireDefault(require("underscore"));
var _constants = require("@studio/constants");
/**
 * @description Sanitize html from string
 * @param {string} str
 * @returns String return sanitised string
 */
var sanitizeHTML = exports.sanitizeHTML = function sanitizeHTML(str) {
  if (!str) {
    return '';
  }
  return str.replace(/[^\w. ]/gi, function (c) {
    return '&#' + c.charCodeAt(0) + ';';
  });
};

/**
 * @description Removes `<H2/>` from presenter banner markup
 * @param {string} markup
 */
function removeH2FromPresenterBannerMarkup(markup) {
  var removeH2 = /<h2[^>]*>[^</]*<\/h2>/gi;
  return markup === null || markup === void 0 ? void 0 : markup.replace(removeH2, '');
}

/**
 * @description Formats presenter banner markup
 * @param {string} title - presenter name.
 * @param {string} description - presenter description.
 * @param {string} markup - html markup.
 * @param {Object} templateVars - template variables.
 * @param {Object} fonts - fonts payload of nameCard.
 * @returns Object
 */
function formatBannerMarkup(title, description, markup, templateVars) {
  var fonts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var bannerStyle = {
    height: '40px',
    position: 'absolute',
    bottom: '5px',
    left: '5px'
  };
  var titleStyle = {};
  var subTitleStyle = {
    paddingBottom: '6px'
  };
  var bannerMarkup = markup;
  // Replace title placeholder with actual presenter title
  bannerMarkup = bannerMarkup.replace(_constants.BANNER_PLACEHOLDERS.title, sanitizeHTML(title));
  if (Object.keys(fonts).length > 0) {
    bannerMarkup = updateBannerFont(bannerMarkup, fonts);
  }
  if (templateVars && templateVars.useAccentAsBackground && templateVars.ACCENT_COLOR) {
    // Replace background color for section
    bannerMarkup = bannerMarkup.replace(/background: #[a-fA-F0-9]+;/g, "background: ".concat(templateVars.ACCENT_COLOR, ";"));
  }
  if (description) {
    // Replace description placeholder with actual presenter description
    bannerMarkup = bannerMarkup.replace(_constants.BANNER_PLACEHOLDERS.description, sanitizeHTML(description));
  } else {
    bannerStyle.height = '27px';
    titleStyle = {
      paddingTop: '5px'
    };
    /**
     * Remove H2 tag `Presenter title` since we don't
     * have source description to display here.
     */
    bannerMarkup = removeH2FromPresenterBannerMarkup(bannerMarkup);
  }
  return {
    bannerStyle: bannerStyle,
    bannerMarkup: bannerMarkup,
    titleStyle: titleStyle,
    subTitleStyle: subTitleStyle
  };
}

/**
 * format banner markup with fonts
 * @param {string} markup - Html banner template
 * @param {object} fonts - Object containing heading and body fonts.
 * @returns {string}
 */
var updateBannerFont = exports.updateBannerFont = function updateBannerFont(markup, fonts) {
  var _fonts$heading, _fonts$body, _fonts$heading3, _fonts$body3;
  if (_underscore["default"].isEmpty(fonts === null || fonts === void 0 || (_fonts$heading = fonts.heading) === null || _fonts$heading === void 0 ? void 0 : _fonts$heading.url) && _underscore["default"].isEmpty(fonts === null || fonts === void 0 || (_fonts$body = fonts.body) === null || _fonts$body === void 0 ? void 0 : _fonts$body.url)) {
    var _markup;
    markup = (_markup = markup) === null || _markup === void 0 ? void 0 : _markup.replace(/<style[^>]*>[^</]*<\/style>/gi, '');
  } else {
    var _fonts$heading2, _fonts$body2;
    if (_underscore["default"].isEmpty(fonts === null || fonts === void 0 || (_fonts$heading2 = fonts.heading) === null || _fonts$heading2 === void 0 ? void 0 : _fonts$heading2.url)) {
      var regexPattern = /@font-face \{ font-family: HEADING_FONT; src: url\("HEADING_FONT_URL"\); }/g;
      markup = markup.split('\n').filter(function (line) {
        return !regexPattern.test(line);
      }).join('\n');
    } else {
      markup = markup.replace('HEADING_FONT_URL', fonts.heading.url);
    }
    if (_underscore["default"].isEmpty(fonts === null || fonts === void 0 || (_fonts$body2 = fonts.body) === null || _fonts$body2 === void 0 ? void 0 : _fonts$body2.url)) {
      var _regexPattern = /@font-face \{ font-family: BODY_FONT; src: url\("BODY_FONT_URL"\); }/g;
      markup = markup.split('\n').filter(function (line) {
        return !_regexPattern.test(line);
      }).join('\n');
    } else {
      markup = markup.replace('BODY_FONT_URL', fonts.body.url);
    }
  }
  if (!_underscore["default"].isEmpty(fonts === null || fonts === void 0 || (_fonts$heading3 = fonts.heading) === null || _fonts$heading3 === void 0 ? void 0 : _fonts$heading3.name)) {
    markup = markup.replace(/\bHEADING_FONT\b/g, "'".concat(fonts.heading.name, "'"));
  }
  if (!_underscore["default"].isEmpty(fonts === null || fonts === void 0 || (_fonts$body3 = fonts.body) === null || _fonts$body3 === void 0 ? void 0 : _fonts$body3.name)) {
    markup = markup.replace(/\bBODY_FONT\b/g, "'".concat(fonts.body.name, "'"));
  }
  return markup;
};